/* Normalize legacy branding supplied by Shopify page content and app widgets.
   Asset URLs and existing page handles must remain intact. */
(() => {
  const normalize = text => text
    .replace(/support@dermatologensval\.com/gi, 'support@canarywharfmd.com')
    .replace(/dermatologensval/gi, 'CanaryWharfMD');
  const update = root => {
    if (root.nodeType === Node.TEXT_NODE) {
      if (root.parentElement?.closest('script, style, textarea, input, [contenteditable]')) return;
      const next = normalize(root.nodeValue);
      if (next !== root.nodeValue) root.nodeValue = next;
      return;
    }
    if (root.nodeType !== Node.ELEMENT_NODE) return;
    if (root.matches('script, style, textarea, input, [contenteditable]')) return;
    for (const attribute of ['alt', 'title', 'aria-label']) {
      const value = root.getAttribute(attribute);
      if (value && normalize(value) !== value) root.setAttribute(attribute, normalize(value));
    }
    const href = root.getAttribute('href');
    if (href && /^mailto:/i.test(href)) {
      const next = href.replace(/support@dermatologensval\.com/gi, 'support@canarywharfmd.com');
      if (next !== href) root.setAttribute('href', next);
    }
    [...root.childNodes].forEach(update);
  };
  update(document.body);
  new MutationObserver(records => {
    records.forEach(record => {
      if (record.type === 'childList') record.addedNodes.forEach(update);
      else update(record.target);
    });
  }).observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['href', 'alt', 'title', 'aria-label'] });
})();
